<img
        *ngIf="showImage"
        [class]="cssClass"
        [src]="resolvedImageUrl"
        [alt]="alt"
        (error)="onImageError()"
/>
<div *ngIf="showInitials" [class]="cssClass + ' org-avatar-fallback'" [attr.aria-label]="alt">
    <span>{{ initials }}</span>
</div>
